import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { PortalAdmin } from "../../../core/models/portal-admin.model";
import { AuthService } from "../../../core/services/client-services/auth.service";

@Component({
  selector: 'app-top-bar',
  standalone: true,
  imports: [],
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.css'
})
export class TopBarComponent implements OnInit {

  currentUser: PortalAdmin | null = null;

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.currentUser = this.authService.getUser();
  }

  @Output() menuToggle = new EventEmitter<void>();
  onMenuClick() { this.menuToggle.emit(); }

  get formattedRole(): string {
    const role = this.currentUser?.corporateRoleKey || '';
    // Convert camelCase to Title Case
    return role.replace(/([A-Z])/g, ' $1').trim()
      .replace(/^./, str => str.toUpperCase());
  }
  
}
